module.exports = __webpack_public_path__ + "static/media/view tour.0d81f1f3.svg";